import { scaleLinear } from 'd3-scale';
import { compact } from 'lodash-es';

import { MeterBarChartThresholdIndicatorProps } from '../types/meter-bar-chart.js';

export const getThresholdIndicators = (
  thresholds: MeterBarChartThresholdIndicatorProps[],
  min: number,
  max: number,
  containerWidth: number,
): number[] => {
  const scale = scaleLinear()
    .domain([min, max])
    .range([0, containerWidth])
    .clamp(true);

  return compact(
    thresholds.map((threshold) =>
      threshold.showIndicator ? scale(threshold.value) : undefined,
    ),
  );
};
